import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import CopyButton from './CopyButton';
import chromelogo from '../chromelogo192.png';

function BrowserChecker (props) {

    const checkMessengerBrowser = () => {
        console.log("checkMessengerBrowser");
        // if (!('Notification' in window) || checkMessengerUserAgent()) {
        if (checkMessengerUserAgent()) {
            console.log("notification not supported");
            handleOpen();
        } else {
            console.log("notification supported");
            
        }
    }

    const checkMessengerUserAgent = () => {
        const ua = navigator.userAgent || '';
        return /FBAN|FBAV|FB_IAB|Messenger/.test(ua);
    };



    useEffect(() => {
        checkMessengerBrowser();
    }, []);

    const [appUrl, setAppUrl] = useState("https://app.qyumo.com");

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return(
        <React.Fragment>
            <Dialog open={open}
            sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "500px",  // Set your width here
                  },
                },
            }}
            style={{
                zIndex: 1301,
            }}
            >
                <DialogContent sx={{ m: 0, p: 4 }}>
                    <Typography sx={{ }} gutterBottom>
                    <b>Incompatible Browser Detected</b>
                    </Typography>
                    
                    <Typography sx={{ }} gutterBottom>
                    Oops! The browser you are using is incompatible with our app. To use our app, please copy the link below and paste it on <b>Google Chrome</b>.
                    </Typography>

                    <Stack direction="column" justifyContent="center" alignItems='center' sx={{ m: 0, p: 2 }} spacing={2}>
                        <img src={chromelogo} alt="" height={30} />
                        <Typography sx={{ }}><b>{appUrl}</b></Typography>
                        <CopyButton string={appUrl} />
                    </Stack>
                    
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default BrowserChecker;